<script>
import { IconCheck, IconRouter, IconAlertTriangleFilled } from "@tabler/icons-vue";
import {resolveDeviceImageUrl} from "@/Composables/DeviceImage.js";

export default {
	name: "DeviceCard",
	components: {IconCheck, IconRouter, IconAlertTriangleFilled},
	props: {
		device: {
			type: Object,
			required: true,
		},
		hideStatus: {
			type: Boolean,
			default: false,
		},
	},
  computed: {
    getSubHeading(){
      return [
        this.device.device_type?.name,
        this.device.device_model?.name,
        this.device.device_revision?.name
      ].filter(_ => _ !== null).join(' / ');
    },
    getImageUrl() {
      return resolveDeviceImageUrl(this.device)
    },
    showDesignation() {
      return this.device.designation && this.device.designation.toLowerCase() !== 'n/a';
    },
  },
}
</script>

<template>
	<Card :pt="{header: { style: { 'border-bottom': '0px' }}}" :class="{
    'border-2 shadow-none': true,
    'border-2 border-amber-500 bg-amber-50 shadow-none': !hideStatus && !device.highlighted && device.requires_update === 1,
    'border-2 border-green-500 bg-green-50 shadow-none': !hideStatus && !device.highlighted && device.requires_update === 0,
    'border-2 border-indigo-400 bg-indigo-50 transform -translate-y-2 shadow-lg transition-all': device.highlighted,
	}">
		<template #header>
			<div class="relative">
				<Tag v-if="showDesignation" class="absolute top-2 right-2 capitalize" severity="secondary" :value="device.designation"/>
				<div class="h-30 aspect-video mx-6 mt-6 rounded-md inline-flex items-center justify-center" :class="{
					'bg-amber-100': !hideStatus && device.requires_update === 1,
					'bg-surface-100': hideStatus || device.requires_update === 0,
				}">
					<img v-if="getImageUrl" :src="getImageUrl" alt="device image" class="h-full mx-auto"/>
					<IconRouter v-else class="w-12 h-12 text-surface-400"/>
				</div>
			</div>
		</template>
		<template #title>
      <router-link data-cy="device-serial-number-value" :to="{name: 'devices.show', params: { device: device.id }}">
        {{ device.serial_number }}
      </router-link>
    </template>
		<template #subtitle>{{ getSubHeading }}</template>
		<template #content>
      <div class="-mt-7 mb-2">
        <span class="text-sm text-surface-500">{{ device.current_firmware?.version_number ?? $t('common.na') }}</span>
      </div>
			<div v-if="!hideStatus" class="flex items-end justify-between">
				<Tag v-if="device.requires_update === 0" severity="success" value="Up to date">
					<template #icon="{ class: iconClass }">
						<IconCheck :class="iconClass" class="w-5 h-5" :stroke-width="2"/>
					</template>
				</Tag>
        <Tag v-if="device.requires_update === 1" severity="warning" value="Update required">
          <template #icon="{ class: iconClass }">
            <IconAlertTriangleFilled :class="iconClass" class="w-5 h-5" :stroke-width="2"/>
          </template>
        </Tag>
			</div>
		</template>
	</Card>
</template>

<style scoped>

</style>
